<template>
  <div
    v-if="modal"
    class="wrapper"
  >
    <div class="card mx-auto">
      <div class="d-flex justify-content-end pt-5 pr-2 p-lg-2">
        <img
          src="@/assets/icon/close.png"
          alt="close"
          class="pointer"
          @click="$emit('close', 'view', false, null)"
        >
      </div>
      <div class="px-5 py-3">
        <h5 class="pb-2 font-weight-bold border-bottom">
          {{ $t('user-profile.header.detail') }}
        </h5>
      </div>
      <div
        v-if="isLoadingForm"
        class="d-flex justify-content-center text-info card-body"
      >
        <div class="spinner-border spinner-border-sm">
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
      <div
        v-else
        class="card-body overflow-auto px-5"
      >
        <div class="d-flex justify-content-center">
          <img
            v-if="!form.avatar"
            src="@/assets/icon/guest.png"
            class="image-width"
            alt="profile-icon"
          >
          <img
            v-if="form.avatar"
            :src="form.avatar"
            class="image-width rounded-circle"
            alt="profile-icon"
          >
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t('user-profile.head.personal') }}
          </h6>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.username') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.username ? form.username : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.fullname') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.fullname ? form.fullname : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.birthdate') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.birthdate ? age + ' / ' + form.birthdate : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.gender') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.gender ? $t('user-profile.form.male') : $t('user-profile.form.female') }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.email') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.email ? form.email : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.address') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.address ? form.address : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.phone') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.phoneNumber ? form.phoneNumber : '-' }}
            </div>
          </div>
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t('user-profile.head.organization') }}
          </h6>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.company-default') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.companyGroup ? form.companyGroup : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.company-itm') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.company ? form.company.name : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.organization') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.workLocation ? form.workLocation.name : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.contractor') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.contractor ? form.contractor.name : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.work-location') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.workLocationActual ? form.workLocationActual : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.nik') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-4 py-1">
              {{ form.nric ? form.nric : '-' }}
            </div>
            <div class="col-sm-3">
              <div
                v-if="form.hrisEmpId"
                class="d-flex justify-content-between my-1"
              >
                <div class="text-success">
                  <small class="font-weight-bold">
                    HRIS Linkage
                  </small>
                </div>
                <img
                  src="@/assets/icon/checklist-green.png"
                  alt="checklist-green"
                >
              </div>
              <div
                v-if="!form.hrisEmpId"
                class="d-flex justify-content-between my-1"
              >
                <div class="text-danger">
                  <small class="font-weight-bold">
                    HRIS Linkage
                  </small>
                </div>
                <img
                  src="@/assets/icon/close.png"
                  alt="wrong"
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.work-unit') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.workUnit ? form.workUnit : '-' }}
            </div>
          </div>
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t('user-profile.head.other') }}
          </h6>
          <div
            v-if="form.companyGroup === 'Guest'"
            class="row"
          >
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.pcr') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div
              class="col-sm-5 py-1 d-flex btn btn-info"
              @click="downloadPcr"
            >
              <img
                src="@/assets/icon/download.png"
                alt="download"
              >
              <p class="m-0 mx-3">
                Download
              </p>
            </div>
          </div>
          <div
            v-if="form.companyGroup === 'Guest'"
            class="row"
          >
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.visit-date') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.visitDate ? form.visitDate : '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.status') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.isActive ? $t('user-profile.status.true') : $t('user-profile.status.false') }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.comorbid') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.comorbid ? $t('user-profile.comorbid.true') : $t('user-profile.comorbid.false') }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{ $t('user-profile.label.role') }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 py-1">
              {{ form.role ? form.role.name : '-' }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4 mb-3">
        <div
          v-if="!form.isActiveDirectory && !isLoadingForm"
          data-toggle="modal"
          data-target="#modalPassword"
          class="col-7 col-sm-3 btn btn-outline-info mx-2"
          @click="showModal('password')"
        >
          <small class="font-weight-bold">
            {{ $t('user-profile.button.password') }}
          </small>
        </div>
        <div
          class="col-7 col-sm-3 btn btn-info mx-2"
          @click="$emit('close', 'view', true, user)"
        >
          <small class="font-weight-bold">
            {{ $t('user-profile.header.update') }}
          </small>
        </div>
      </div>
    </div>
    <ModalPassword
      :id="form.id"
    />
  </div>
</template>

<script>
import { format, differenceInYears } from 'date-fns'
import Api from '@/utils/Api'
import FileSaver from 'file-saver'
import ModalPassword from '@/components/modal/password/ModalPassword'

export default {
  components: {
    ModalPassword
  },

  props: {
    modal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      form: {},
      isLoadingForm: false,
      modalView: {
        password: false
      }
    }
  },

  computed: {
    age () {
      return differenceInYears(new Date(), new Date(this.form.birthdate))
    }
  },

  created () {
    this.initial()
  },

  methods: {
    async initial () {
      this.isLoadingForm = true
      const data = await Api.users.get(this.user.id)
      this.form = data.data
      this.form.birthdate = format(new Date(this.form.birthdate), 'yyyy-MM-dd')
      this.form.visitDate = format(new Date(this.form.visitDate), 'yyyy-MM-dd')
      this.isLoadingForm = false
    },
    downloadPcr () {
      const fileName = `'PCR'_'${this.form.fullname}'.pdf`
      FileSaver.saveAs(this.form.pcrSwabTest, fileName)
    },
    showModal (modalname) {
      this.modalView[modalname] = true
    },
    closeModal (modalname) {
      this.modalEdit[modalname] = false
    }
  }
}
</script>

<style scoped>
.wrapper {
  align-items: center;
  display: flex;
  background-color: rgba(87, 85, 85, 0.473);
  padding-left: 0;
  z-index: 10;
}
.card {
  margin: 0 auto;
  width: 800px;
  border-radius: 18px;
}
.card-body {
  height: 400px;
}
.pointer {
  cursor: pointer;
}
.image-width {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>
